import { axios } from "lib/axios";

export const resetPassword = data => {
  return axios.post("/auth/reset_password", data);
};
